
import { Auth } from 'aws-amplify';
import Axios from 'axios';

/**
 * Token Interceptor
 * @param {*} config
 * @returns {*}
 */
async function authRequestInterceptor(config) {
    const user = (await Auth.currentAuthenticatedUser());
    const accessToken = user.signInUserSession.idToken.jwtToken;
    if (accessToken) {
        config.headers.authorization = `Bearer ${accessToken}`;
    }
    config.headers.Accept = 'application/json';
    return config;
}


const httpClient = Axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Add a request interceptor
httpClient.interceptors.request.use(authRequestInterceptor);

// Add a response interceptor
httpClient.interceptors.response.use(
    (response) => {
        // You can modify the response here (e.g., data transformation)
        return response.data;
    },
    (error) => {
        // You can handle errors globally here
        return Promise.reject(error.response);
    }
);

export default httpClient;
